import React, { Fragment } from 'react';

import { token } from '@atlaskit/tokens';

import type { ColorTable } from './types';

export const CATEGORICAL_CHART_TOKENS: ColorTable[] = [
	{
		name: 'color.chart.categorical.1',
		description: <Fragment>For data visualization only. Follow the numbered sequence.</Fragment>,
		token: token('color.chart.categorical.1'),
	},
	{
		name: 'color.chart.categorical.2',
		description: <Fragment>For data visualization only. Follow the numbered sequence.</Fragment>,
		token: token('color.chart.categorical.2'),
	},
	{
		name: 'color.chart.categorical.3',
		description: <Fragment>For data visualization only. Follow the numbered sequence.</Fragment>,
		token: token('color.chart.categorical.3'),
	},
	{
		name: 'color.chart.categorical.4',
		description: <Fragment>For data visualization only. Follow the numbered sequence.</Fragment>,
		token: token('color.chart.categorical.4'),
	},
	{
		name: 'color.chart.categorical.5',
		description: <Fragment>For data visualization only. Follow the numbered sequence.</Fragment>,
		token: token('color.chart.categorical.5'),
	},
	{
		name: 'color.chart.categorical.6',
		description: <Fragment>For data visualization only. Follow the numbered sequence.</Fragment>,
		token: token('color.chart.categorical.6'),
	},
	{
		name: 'color.chart.categorical.7',
		description: <Fragment>For data visualization only. Follow the numbered sequence.</Fragment>,
		token: token('color.chart.categorical.7'),
	},
	{
		name: 'color.chart.categorical.8',
		description: <Fragment>For data visualization only. Follow the numbered sequence.</Fragment>,
		token: token('color.chart.categorical.8'),
	},
];
